
<template>
  <Head>
    <title>
      {{ title ? title + " | " : "" }}{{ $page.props.config.app.name }}
    </title>
    <meta name="robots" content="index,follow" />
    <link rel="canonical" head-key="canonical" :href="canonicalUrl" />
    <meta
      name="description"
      :content="(metaDescription ? metaDescription : 'Auf uns können Sie sich verlassen, wenn es um Ihren Skiurlaub in der Gruppe mit Familie, den Skispaß mit Freunden oder den Winterurlaub zu zweit in den einmalig schönen Skigebieten Österreichs geht. Wir haben für jeden Winterurlauber das passende Angebot.')"
    />
    <meta
      name="keywords"
      :content="(metaKeywords ? metaKeywords : 'Gruppenreisen, Skireisen, Gruppe, Skiurlaub, Busreisen')"
    />

    <slot name="head"></slot>
  </Head>
  <div id="wrapper">
    <header
      id="header"
      class="fixed-top header-standard"
      :class="{ 'header-compact': compactHeader }"
    >
      <nav class="navbar navbar-expand-lg navbar-light">
        <div class="container-xl justify-content-end">
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div id="header-logo" class="d-block d-lg-none">
            <Link :href="$route('home')">
              <img
                :src="$page.props.page.assets.logo"
                alt="SCOL Skireisen Logo"
              />
            </Link>
          </div>

          <div
            class="collapse navbar-collapse justify-content-center"
            id="navbarNav"
          >
            <div class="row flex-grow-1 navbar-nav mx-0">
              <div class="col nav-item">
                <Link
                  class="nav-link"
                  :class="{ active: $page.url.startsWith('/urlaubsziele') }"
                  :href="$route('vacation')"
                >
                  <img
                    :src="$page.props.page.assets.vacation"
                    alt="Urlaubsziele Icon"
                  />
                  <br />Urlaubsziele
                </Link>
              </div>
              <div class="col nav-item">
                <Link
                  class="nav-link"
                  :class="{ active: $page.url.startsWith('/angebote') }"
                  :href="$route('offer')"
                >
                  <img
                    :src="$page.props.page.assets.offer"
                    alt="Sommer Icon"
                  />
                  <br />Sommer
                </Link>
              </div>
              <div class="col nav-item">
                <Link
                  class="nav-link"
                  :class="{ active: $page.url.startsWith('/anreise') }"
                  :href="$route('arrival')"
                >
                  <img
                    :src="$page.props.page.assets.arrival"
                    alt="Anreise Icon"
                  />
                  <br />Anreise
                </Link>
              </div>
              <div id="nav-logo" class="col-lg-3">
                <Link :href="$route('home')">
                  <img
                    :src="$page.props.page.assets.logo"
                    alt="SCOL Skireisen Logo"
                  />
                </Link>
              </div>
              <div class="col nav-item">
                <Link
                  class="nav-link"
                  :class="{ active: $page.url.startsWith('/ueber-uns') }"
                  :href="$route('about-us')"
                >
                  <img
                    :src="$page.props.page.assets['about-us']"
                    alt="Über Uns Icon"
                  />
                  <br />Über Uns
                </Link>
              </div>
              <div class="col nav-item">
                <Link
                  class="nav-link"
                  :class="{ active: $page.url.startsWith('/jobs') }"
                  :href="$route('jobs')"
                >
                  <img :src="$page.props.page.assets.jobs" alt="Jobs Icon" />
                  <br />Jobs
                </Link>
              </div>
              <div class="col nav-item">
                <Link
                  class="nav-link"
                  :class="{ active: $page.url.startsWith('/kontakt') }"
                  :href="$route('contact')"
                >
                  <img
                    :src="$page.props.page.assets.contact"
                    alt="Kontakt Icon"
                  />
                  <br />Kontakt
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>

    <main id="main" :class="{ 'no-banner': !banner.src }">
      <section
        v-if="banner.src"
        class="banner-top"
        :class="{ full: banner.type == 'full' }"
        :style="h1Style"
      >
        <div class="scol-caption" v-if="h1">
          <h1>{{ h1 }}</h1>
        </div>
        <slot name="banner-overlay" />
      </section>
      <slot />
    </main>

    <Footer />

    <login-modal />
  </div>
</template>


<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import LoginModal from "../../Components/Auth/LoginModal.vue";
import Footer from "../../Components/Scol/Footer";

export default {
  components: {
    Head,
    Link,
    LoginModal,
    Footer,
  },
  props: {
    title: String,
    metaKeywords: String,
    metaDescription: String,
    canonical: String,
    banner: {
      type: Object,
      default: {
        src: null,
        type: "stretch",
      },
    },
    h1: String,
    compactHeader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    canonicalUrl() {
      return this.canonical || this.$page.props.page.canonical;
    },
    h1Style() {
      if (!this.banner.src) {
        return;
      }

      let style = "background-image: url('" + this.banner.src + "')";

      if (this.banner.position) {
        style += ";background-position: " + this.banner.position;
      }

      return style;
    },
  },
    mounted(){
 if (getCookieValue("googleads") == true) {
        var head = document.getElementsByTagName("head")[0];
        var script = document.createElement("script");

        script.text = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('consent', 'update', {
                'ad_storage': 'granted',
                'analytics_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted'
            });
        `;

        head.insertBefore(script, head.firstChild);
    }

        if (getCookieValue("googleanalytics") == true) {
      var head = document.getElementsByTagName("head")[0];
      var script = document.createElement("script");

      script.text =
        "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':" +
        "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," +
        "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
        "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" +
        "})(window,document,'script','dataLayer','GTM-PSGCN7PH');";

      head.insertBefore(script, head.firstChild);

      var body = document.getElementsByTagName("body")[0];
      var noscript = document.createElement("noscript");

      var iframe = document.createElement("iframe");
      iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-PSGCN7PH";
      iframe.height = "0";
      iframe.width = "0";
      iframe.style.display = "none";
      iframe.style.visibility = "hidden";

      noscript.appendChild(iframe);

      body.insertBefore(noscript, body.firstChild);
    }
    if (getCookieValue("facebookpixel") == true) {
        var scriptTag = document.createElement('script');
        scriptTag.innerHTML = `
            !function(f,b,e,v,n,t,s) {
                if(f.fbq)return;
                n=f.fbq=function(){
                    n.callMethod ?
                    n.callMethod.apply(n,arguments) : n.queue.push(arguments)
                };
                if(!f._fbq)f._fbq=n;
                n.push=n;
                n.loaded=!0;
                n.version='2.0';
                n.queue=[];
                t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)
            }(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '911865391057583');
            fbq('track', 'PageView');
        `;
        document.head.appendChild(scriptTag);

        var noscriptTag = document.createElement('noscript');
        var imgTag = document.createElement('img');
        imgTag.height = 1;
        imgTag.width = 1;
        imgTag.style.display = 'none';
        imgTag.src = "https://www.facebook.com/tr?id=911865391057583&ev=PageView&noscript=1";
        noscriptTag.appendChild(imgTag);
        document.head.appendChild(noscriptTag);
    }
}
};
</script>
